import { render, staticRenderFns } from "./consultDetailBox.vue?vue&type=template&id=2d599e3e&scoped=true"
import script from "./consultDetailBox.vue?vue&type=script&lang=js"
export * from "./consultDetailBox.vue?vue&type=script&lang=js"
import style0 from "./consultDetailBox.vue?vue&type=style&index=0&id=2d599e3e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d599e3e",
  null
  
)

export default component.exports